<template>
  <section>
    <!-- 统计文字 -->
    <el-row class="total">
      <el-card class="box-card xs24" shadow="hover">
        <i class="el-icon-tickets sicon one"></i>
        <span class="tjContent">
          <div>收入</div>
          <div class="numText one">{{cdata.income||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card xs24" shadow="hover">
        <i class="el-icon-success sicon two"></i>
        <span class="tjContent">
          <div>计价数</div>
          <div class="numText two">{{cdata.num||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card xs24" shadow="hover">
        <i class="el-icon-news sicon three"></i>
        <span class="tjContent">
          <div>转化率</div>
          <div class="numText three" >{{cdata.clickok_per||'0'}}%</div>
        </span>
      </el-card>
       <el-card class="box-card xs24" shadow="hover">
        <i class="el-icon-news sicon three"></i>
        <span class="tjContent">
          <div>点击成功UV</div>
          <div class="numText three" >{{cdata.clickok_uv||'0'}}</div>
        </span>
      </el-card>
    </el-row>
   <el-row class="statusRowWhite" >
			<div class="RowChild">
				&nbsp;日期：	&nbsp;
	      <el-button class="xs24"  type="primary" id="yesterday" plain @click="changeDate(1)">昨天</el-button>
	      <el-button class="xs24" type="primary" id="seven" plain @click="changeDate(7)">最近7天</el-button>
      
          <el-date-picker
          	class="xs24"
            v-model="dateVal"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="今天"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>
      </div>  
      <div class="RowChild">
				&nbsp;操作：&nbsp;
          <el-button class="xs24" type="primary" plain @click="oneKey(0)" v-if="dateVal[0]===dateVal[1]">一键分配收入</el-button>
          <el-button class="xs24" type="primary" plain @click="onePrice(0)" v-if="dateVal[0]===dateVal[1]">一键同步收入</el-button>
          <el-button size="medium" type="primary" @click="collectDialog=true">采集</el-button>
          <el-button size="medium" type="primary" @click="batchAddProduct">导入</el-button>
          
     			<el-button size="medium" type="text" @click="downloadTemp">导入模板下载</el-button>
     			<el-checkbox v-model="abnormity" @change="abnormityCg">筛选异常数据</el-checkbox>
     	</div>  
          <!--<el-dropdown class="dropdown" @command="placementFilter">
	        <el-button type="normal" class="dropdown">
	          {{pText}}
	          <i class="el-icon-arrow-down el-icon--right"></i>
	        </el-button>
	        <el-dropdown-menu slot="dropdown" class="dropdown-menu">
	          <el-dropdown-item command>所有投放位置</el-dropdown-item>
	          <el-dropdown-item v-for="(v,i) in options" :key="i" :command="v">{{v}}</el-dropdown-item>
	        </el-dropdown-menu>
	      </el-dropdown>-->
	      
	      
	      
  

      
  
   			<div class="RowChild">
				&nbsp;筛选：	&nbsp;
      		<el-select class="xs24" v-model="pdata.placement_id" placeholder="所有投放位置" clearable filterable @change="placementFilter">
					     <el-option
					      v-for="item in option"
					      :key="item.name"
					      :label="item.name"
					      :value="item.issued_app_id">
					    </el-option>
					  </el-select>
					  
           <!-- <el-button type="primary" round @click="toogleChart">图表</el-button>-->
         	  <el-select class="xs24" v-model="pdata.source" filterable  clearable placeholder="请选择来源">
			        <el-option v-for="(item,i) in sources" :key="item.value" :label="item.name" :value="item.value"></el-option>
			      </el-select>

            <el-input
              style="width:170px"
              @clear="getList"
              @keyup.enter.native="search"
              ref="input"
              class="search xs24"
              v-model="pdata.product_name"
              clearable
              placeholder="请输入产品名称"
              :suffix-icon="pdata.product_name.length>0?'':'el-icon-search'"
            ></el-input>
					</div> 
   

    </el-row>

    <!-- 图表 -->
    <el-row style="min-width:1200px" v-show="!isChartShow">
      <div id="chart" style="width:100%; height:500px;"></div>
    </el-row>
    <!--列表-->
    <el-table
    	v-loading="loading"
      class="data selfTable"
      :data="tableList"
      style="width: 100%;min-width:1200px"
      row-key="product_id"
      stripe
      :row-class-name="tableRowClassName"
      @expand-change="expands"

     
    >
      <el-table-column type="expand" prop="name" v-if="dateVal[0]!==dateVal[1]"  class="expandd">
        <template slot-scope="s">
          <!-- 折叠 -->
          <el-table :data="s.row.exData" :show-header="false"  class="table2">
            <el-table-column prop="d_date" label="日期" align="center" width="100px"></el-table-column>
            <el-table-column prop="name" label="产品名称" align="center"></el-table-column>
            <el-table-column  prop="placement" label="投放位置" align="center"></el-table-column>
            <el-table-column  prop="company" label="公司名称" align="center"></el-table-column>
            
            <el-table-column prop="source" label="来源" align="center">
            	 <template slot-scope="s">
                	<span v-if="s.row.source==1">互导</span>
                	<span v-if="s.row.source==2">卖量</span>
                	<span v-if="s.row.source==3">测量</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="计价方式" align="center"></el-table-column>
            <el-table-column prop="num" label="计价数" align="center">
              <template slot-scope="s">
                <div :class="s.row.num==0&&s.row.clickok_uv!=0?'noNum':''">{{s.row.num}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="income" label="收入" align="center"></el-table-column>
            <!--<el-table-column prop="click_pv" label="点击pv" align="center"></el-table-column>-->
            <!--<el-table-column prop="click_uv" label="点击uv" align="center"></el-table-column>-->
            <el-table-column prop="clickok_uv" label="点击成功uv" align="center"></el-table-column>
            <el-table-column prop="unit" label="点击单价 " align="center"></el-table-column>
            <el-table-column prop="conversion_per" label="转化单价" align="center">
              <template slot-scope="scope">
                <span :class="scope.row.conversion_per>90?'red':''">{{scope.row.conversion_per}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="jump_per" label="跳出率" align="center" >
			        <template slot-scope="scope">
			          {{scope.row.jump_per}}%
			        </template>
			      </el-table-column>
            <el-table-column label="操作" width="150px">
            	<template slot-scope="scope">
			          <el-button
			            size="mini"
			            type="primary"
			            @click="geng(scope.row,s.$index)"
			          
			          >更新</el-button>
			         <!--  <el-button size="mini" type="primary" @click="jump(scope.row.adminurl)" v-if="(dateVal[0]===dateVal[1])&&scope.row.adminurl!=''">后台</el-button>-->
			        </template>
            </el-table-column>
          </el-table>
          <!-- 折叠结束 -->
        </template>
      </el-table-column>
      <el-table-column prop="product_id" label="ID" width="100px" align="center"></el-table-column>
      <el-table-column prop="name" label="产品名称" align="center" sortable   :sort-method="sortDevName" ></el-table-column>
      <el-table-column  prop="placement" label="投放位置" align="center" sortable :sort-method="sortPlaceName"></el-table-column>
      <el-table-column  prop="company" label="公司名称" align="center" sortable :sort-method="sortCompanyName"></el-table-column>
      <el-table-column prop="source" label="来源" align="center">.
      	<template slot-scope="s">
        	<span v-if="s.row.source==1">互导</span>
        	<span v-if="s.row.source==2">卖量</span>
        	<span v-if="s.row.source==3">测量</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="计价方式" align="center"></el-table-column>
      <el-table-column
        class-name
        prop="num"
        label="计价数"
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.num-0)-(b.num-0)}"
      >
        <template slot-scope="s">
          <div :class="s.row.num==0&&s.row.clickok_uv!=0?'noNum':''">{{s.row.num}}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="income"
        label="收入"
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.income-0)-(b.income-0)}"
      ></el-table-column>
      <!--<el-table-column
        prop="click_pv"
        label="点击pv"
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.click_pv-0)-(b.click_pv-0)}"
      ></el-table-column>-->
      <!--<el-table-column
        prop="click_uv"
        label="点击uv"
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.click_uv-0)-(b.click_uv-0)}"
      ></el-table-column>-->
      <el-table-column
        prop="clickok_uv"
        label="点击成功uv"
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.clickok_uv-0)-(b.clickok_uv-0)}"
      ></el-table-column>
      <el-table-column
        prop="unit"
        label="点击单价 "
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.unit-0)-(b.unit-0)}"
      >
       <template slot-scope="scope">
          <span  :class="(scope.row.income/scope.row.clickok_uv)>scope.row.unit?'red':''">{{scope.row.unit}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="conversion_per"
        label="转化单价"
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.conversion_per-0)-(b.conversion_per-0)}"
      >
        <template slot-scope="scope">
          <span  :class="scope.row.conversion_per>90?'red':''">{{scope.row.conversion_per}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="jump_per"
        label="跳出率"
        align="center"
        sortable
        :sort-method="(a,b)=>{return (a.jump_per-0)-(b.jump_per-0)}"
      >
        <template slot-scope="scope">
          {{scope.row.jump_per}}%
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150px">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="geng(scope.row)"
            v-if="dateVal[0]===dateVal[1]"
          >更新</el-button>
<!--          <el-button size="mini" type="primary" @click="jump(scope.row.adminurl)" v-if="(dateVal[0]===dateVal[1])&&scope.row.adminurl!=''">后台</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <!--<div class="pageRow">
      <el-pagination
        class="pagination"
        @size-change="SizeChange"
        @current-change="CurrentChange"
        :current-page.sync="pdata.page"
        :page-sizes="[20, 40, 60, 80]"
        :page-size="pdata.perpage"
        background
        layout="sizes, prev, pager, next, jumper"
        :total="pdata.perpage*maxPage"
      ></el-pagination>
    </div>-->
    <el-dialog
      title="更新产品数据"
      :visible.sync="editDialog"
      class="dialog"
      :close-on-click-modal="false"
    >
      <el-form :model="choose">
        <el-form-item label="计价单价" :label-width="'120px'">
          <el-input v-model="choose.unit"></el-input>
        </el-form-item>
        <el-form-item label="计价数" :label-width="'120px'">
          <el-input v-model="choose.num" @keyup.enter.native="pupdate"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="pupdate">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="分配收入记录" :visible.sync="logDialog" width="600px">
      <el-table :data="plog" max-height="600">
        <el-table-column label="日期" :width="'150px'">{{this.dateVal[0]}}</el-table-column>
        <el-table-column prop="msg" label="分配记录" :width="'350px'"></el-table-column>
      </el-table>
    </el-dialog>
    
    <el-dialog title="批量增加" :visible.sync="batchDialog" width="1000px" :close-on-click-modal="false">
      <el-form  ref="ruleForm" label-width="140px">

				
				<el-upload
				v-if="batchForm.length==0"
			  class="upload-demo"
			  drag
			  :action="url"
				 :headers="headers"
				  :on-success="batchSuccess"
				  name="file"
				  :show-file-list="false"
				 >
			  <i class="el-icon-upload"></i>
			  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
			  <div class="el-upload__tip" slot="tip">只能上传csv文件</div>
			</el-upload>
      </el-form>
       
      <el-row :gutter="5" class="yltt" v-if="batchForm.length>0" >
       	<el-col  :span="24">{{batchTips}}</el-col>
       </el-row>
       
      
       
       <el-row :gutter="5" v-for="item,index in batchForm" class="yllist" :class="'yllist'+index" v-if="batchForm.length>0">
       		<el-col  :span="(idx==6||idx==4||idx==7)?2:3" v-for="(citem,idx) in  item">
       				{{citem==''?'&nbsp;':citem}}
       		</el-col>	
       		
       </el-row>
      


      <div slot="footer" class="dialog-footer" v-if="batchForm.length>0">
        <el-button @click="batchCalcel">取 消</el-button>
        <el-button type="primary" @click="batchSubmit" v-if="this.batchTips=='导入预览'">确 定</el-button>
       
      </div>
    </el-dialog>
    
    
    
      <el-dialog title="卖量数据计价数采集微信数据" :visible.sync="collectDialog" class="dialog" :close-on-click-modal="false">
      <el-form :model="collectForm">
       	<el-input type="textarea"  :rows="8" placeholder="请输入cookie" v-model="collectForm.cookie"></el-input>
      </el-form>
       

      <div slot="footer" class="dialog-footer" >
        <el-button @click="collectDialog=false">取 消</el-button>
        <el-button type="primary" @click="collectIncome" >开始采集</el-button>
       
      </div>
    </el-dialog>
    
    <el-dialog title="采集记录" :visible.sync="collectLogDialog" width="600px">
      <el-table :data="collectLog"  style="width:100%">
        <el-table-column label="序号" width="50px"> 
        	<template slot-scope="scope">
	            <span>{{scope.$index+1}}</span>
	          </template>
        </el-table-column>
        <el-table-column prop="name" label="采集名称">
	    		  <template slot-scope="scope">
	            <span>{{scope.row.name}}采集成功</span>
	          </template>
        </el-table-column>
      </el-table>
       <div slot="footer" class="dialog-footer" >
        <el-button @click="collectLogDialog=false">关闭</el-button>
      
       
      </div>
    </el-dialog>
    
    
    

    
  </section>
</template>

<script>
import { sidata2, spupdate2, sOneKey2, sOnePrice2, pdataEx2,getPlacementList ,baseUrl,PostBitchAddIncome,PostCollectIncome} from "../../api/api";
import echarts from "echarts";

export default {
  data() {
    return {
      logDialog: false,
      isChartShow: true,
      chartColumn: null,
      timer: null,
      pdata: {
      	placement:'',
        page: 1,
        perpage: 20,
        theme: "",
        placement_id: "",
        product_name:"",
        source:"",
        app_id: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
        // sdate: "2019-04-01",
        // edate: "2019-04-01"
      },
      tText: "请选择产品类型",
      pText:"请选择产品投放位置",
      plist: [],
      maxPage: 1,
      config: [],
      sources:[],
      group: {},
      editDialog: false,
      choose: { index_id: "", unit: "0", num: "0" },

      dateVal: [
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 }, //所有数据
      tableList:[],
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["转化率", "收入", "计价次数"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "转化率",
            type: "line",
            smooth: true,
            data: []
          },
          {
            name: "收入",
            type: "line",
            smooth: true,
            data: []
          },
          {
            name: "计价次数",
            type: "line",
            smooth: true,
            data: []
          }
        ],
        color: [
          "#61c0a0",
          "#ee4f54",
          "#8ec1b0",
          "#a6e8ba",
          "#ceead4",
          "#f2e247",
          "#f6e98b",
          "#f77b31",
          "#fc9656",
          "#ec151a",
          "#ee4f54",
          "#ee2159",
          "#fbaaa6"
        ]
      },
      options: [], //投放位置配置

      plog: [], //分配收入日志
      toggleRowExpansionNum:'',
      form:[],
      batchDialog:false,
   		batchForm:[],
			batchTips:'导入预览',
			url:baseUrl+"income/preview",
			headers:{
          'token':this.$cookie.getCookie("login")
      },
      collectDialog:false,
      collectForm:{index_id:0,cookie:''},
      collectLog:[],
      collectLogDialog:false,
      abnormity:false,
      oldlist:[],
      loading:false,
      pertime:''
    };
  },
  watch: {
    dateVal: {
      handler(n, o) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
      },
      deep: true
    },
    'pdata.placement_id':{
    	 handler(n, o) {
				this.getList();
      },
      deep: true
    },
    'pdata.product_name':{
    	 handler(n, o) {
				this.getList();
      },
      deep: true
    },
    'pdata.source':{
    	 handler(n, o) {
    	 	
        this.getList();
      },
      deep: true
    }
  },
  methods: {
  		abnormityCg(val){
  			clearInterval(this.pertime);
  			var _this=this;
  			console.log(this.abnormity);
  			this.tableList=[]
  			this.loading=true;
  			
  			if(val==true){
  				var tempArr=[];
  				this.oldlist.forEach((v,i)=>{
  					if(v.conversion_per-0>v.unit-0){
  						tempArr.push(v)
  					}
  				});
  				this.tableList = tempArr;
  				
  			}
  			else{
  				var i=0;
  				var tempArr=[];
  				var pernum = 50;
				//	this.tableList = this.oldlist;
					
					this.pertime = setInterval(()=>{
						
						if(i*pernum>_this.oldlist.length){
							clearInterval(this.pertime);
						}
						else{
							i++;
							if(i*pernum+pernum>_this.oldlist.length){
								tempArr=	tempArr.concat(_this.oldlist.slice(i*pernum,_this.oldlist.length))
							}
							else{
								tempArr=	tempArr.concat(_this.oldlist.slice(i*pernum,i*pernum+pernum));
							}
						
//							console.log(i*pernum,_this.oldlist.length);
							
						}
						_this.tableList=tempArr;
						
					},25);
  			}
  			this.loading=false;
  			
//			setTimeout(()=>{
//				this.loading=false;
//			},500)
  			
  			
  			
  		},
  	  sortDevName(str1,str2){
  	  	return this.DevName_fn(str1.name,str2.name)
  	  },
  	  sortPlaceName(str1,str2){
  	  	return this.DevName_fn(str1.placement,str2.placement)
  	  },
  	  sortCompanyName(str1,str2){
  	  	return this.DevName_fn(str1.company,str2.company)
  	  },
  		DevName_fn(str1, str2) {
        let res = 0
        for (let i = 0; ;i++) {
				if (!str1[i] || !str2[i]) {
				  res = str1.length - str2.length
				  break
				}
				const char1 = str1[i]
				const char1Type = this.getChartType(char1)
				const char2 = str2[i]
				const char2Type = this.getChartType(char2)
				// 类型相同的逐个比较字符
				if (char1Type[0] === char2Type[0]) {
				  if (char1 === char2) {
					continue
				  } else {
					if (char1Type[0] === 'zh') {
					  res = char1.localeCompare(char2)
					} else if (char1Type[0] === 'en') {
					  res = char1.charCodeAt(0) - char2.charCodeAt(0)
					} else {
					  res = char1 - char2
					}
					break
				  }
				} else {
				// 类型不同的，直接用返回的数字相减
				  res = char1Type[1] - char2Type[1]
				  break
				}
			  }
			  return res
			},
			getChartType(char) {
			// 数字可按照排序的要求进行自定义，我这边产品的要求是
			// 数字（0->9）->大写字母（A->Z）->小写字母（a->z）->中文拼音（a->z）
			  if (/^[\u4e00-\u9fa5]$/.test(char)) {
				return ['zh', 300]
			  }
			  if (/^[a-zA-Z]$/.test(char)) {
				return ['en', 200]
			  }
			  if (/^[0-9]$/.test(char)) {
				return ['number', 100]
			  }
			  return ['others', 999]
			},
//	卖量数据计价数采集微信数据
  	collectIncome(type){
  		if(type!='coutinue'){
  			  this.collectForm.index_id=0;
  				this.collectLog=[];
  				this.collectLogDialog=false;
  				
  		}
			this.collectDialog=false;
      
      this.collectForm.sdate=this.pdata.sdate;
      this.collectForm.edate=this.pdata.edate;
     
  		PostCollectIncome(this.collectForm, this.$cookie.getCookie("login")).then(res => {
  		 
  		 	 if(res.code==200){
  		 	 		if(res.data.id){
  		 	 				this.collectForm.index_id=res.data.id;
  		 	 				this.collectLog.unshift(res.data);
  		 	 				this.collectLogDialog=true;
  		 	 				this.collectIncome('coutinue');
  		 	 		}
  		 	 		else{
  		 	 				this.$message({ message: "数据采集完成", type: "success" });
  		 	 		}
  		 	 	
  		 	 }
  		 	 else if(res.code==401){
  		 	 	this.$message.error(res.msg);
  		 	 }
  		 	 else{
  		 	 		this.$message.error(res.msg);
  		 	 }
  		 	
  		 })
  	},
  	
  	downloadTemp(){
  		window.location.href='/static/sdk_product_income.csv';
  	},
  	batchSuccess(response, file, fileList){

  		if(response.code==200){
  			this.batchForm=response.data;
  		}
  		
  		
  	},
  	//批量增加
  	batchAddProduct(){
  		this.batchDialog=true;
  	},
  	batchCalcel(){
    	this.batchDialog = false;
    	this.batchForm=[];
    	this.batchTips="导入预览"
    },
    batchSubmit(){
      PostBitchAddIncome({data:this.batchForm}, this.$cookie.getCookie("login")).then(response => {
        if (response.code == 200) {
         	 if(response.data.length>0){
         	 	 
        			this.batchForm=response.data;
        			this.batchTips="以下数据未成功导入";
        			
        			
         	 }
         	 else{
         	 	 this.$message({ message: "导入成功", type: "success" });
         	 	 this.batchDialog = false;
         	 	 this.batchForm=[];
         	 	 this.getList();
         	 }
        }
        else{
        	this.$message.error('导入失败');
        	 
        }
     });
    },
	  placementFilter(s){
	    	this.pText = s == "" ? "请选择产品投放位置" : s;
	    	this.pdata.placement = s;
	    	this.getList();
	   },
    getList() {
    	this.loading=true;
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      sidata2(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.cdata = res.data.total;
          if (res.data.list!=null&&res.data.list.length > 0) {
            res.data.list.forEach((x,i) => {
	            	x.keyid='key'+i;
	              x.exData = [];
	              x.ex
	            });
          }
          else{
          	 res.data.list=[];
          }
          this.tableList= res.data.list;
   				this.oldlist = res.data.list;
   				this.loading=false;
          this.$forceUpdate();
          
           setTimeout(()=>{
	            	if(this.toggleRowExpansionNum!==''){
	            		this.expands(this.tableList[this.toggleRowExpansionNum],null,true);
		               //	document.getElementsByClassName('el-table__expand-icon')[this.toggleRowExpansionNum].click();
		            	this.toggleRowExpansionNum='';
		            }
	            },500)

//        this.option.xAxis.data = res.data.chart.date;
//        this.option.series[0].data = res.data.chart.click_per;
//        this.option.series[1].data = res.data.chart.income;
//        this.option.series[2].data = res.data.chart.num;
//        this.drawColumnChart();
        }
      });
      getPlacementList('', this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
       		
          this.option = res.data.list;
        }
      });
    },
    getConfig() {
      if (this.$store.config) {
        this.tags = this.$store.config.product_tag;
        this.sources=[{name:"互导",value:"1"},{name:"卖量",value:"2"},{name:"测量",value:"3"}];
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },
    drawColumnChart() {
      this.chartColumn = echarts.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    themeFilter(s) {
      this.tText = s == "" ? "请选择产品类型" : s;
      this.pdata.theme = s;
      this.getList();
    },
    search() {
      // 有问题;
      this.getList();
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate(s) {
      this.dateVal = [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ];
      // this.getList();
    },
    geng(s,ss) {
      this.editDialog = true;
      this.choose.index_id = s.id;
      this.choose.unit = s.unit;
      this.choose.num = s.num;
      debugger;
      if(ss!=undefined){
    		this.toggleRowExpansionNum=ss;
    	}
    	else{
    		this.toggleRowExpansionNum='';
    	}
    },
    pupdate() {
      if (this.choose.num) {
        spupdate2(this.choose, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            this.$message({
              message: "更新成功",
              type: "success"
            });
            this.editDialog = false;
            this.getList();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    jump(url) {
      window.open(url, "_blank");
    },
    toogleChart() {
      this.isChartShow = !this.isChartShow;
      var that = this;
      setTimeout(() => {
        that.chartColumn.resize();
      }, 100);
    },
    oneKey(id = 0) {
      this.$confirm("确定一键更新分配收入?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.diedai(0);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消更新分配"
          });
        });
    },
    diedai(id = 0) {
      if (id == 0) {
        if (!this.logDialog) {
          this.logDialog = true;
        }
        this.plog = [];
      }
      if (this.logDialog) {
        var p = this.dateVal[0].replace(/-/g, "");
        sOneKey2(id, p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            if (res.data.index_id != 0) {
              this.plog.unshift(res);
              this.diedai(res.data.index_id);
            } else {
              this.$message({ message: "更新完成", type: "success" });
            }
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    onePrice(id = 0) {
      this.$confirm("确定一键同步收入?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.onePricePost(0);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消更新分配"
          });
        });
    },
    onePricePost(id = 0) {
      if (id == 0) {
        if (!this.logDialog) {
          this.logDialog = true;
        }
        this.plog = [];
      }
      if (this.logDialog) {
        var p = this.dateVal[0].replace(/-/g, "");
        sOnePrice2(id, p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            if (res.data.index_id != 0) {
              this.plog.unshift(res);
              this.onePricePost(res.data.index_id);
            } else {
              this.$message({ message: "更新完成", type: "success" });
            }
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },

    tableRowClassName({ row, rowIndex }) {
      if (row.clickok_uv == 0 && row.num != 0) {
        return "warning-row";
      }
      return "";
    },
    expands(r, es,isshow) {
    
      var isshou = false;
      if (es&&es.length > 0) {
        es.forEach(v => {
          if (v.product_id == r.product_id) {
            isshou = true;
          }
        });
      }
      if(isshow){
      	isshou = true;
      }
	    if (isshou) {
	      	var p=`&issued_app_id=${r.issued_app_id}&product_id=${r.product_id}&sdate=${this.dateVal[0]}&edate=${
	          this.dateVal[1]
	        }`;
	//      var p = `creative_id=${r.creative_id}&sdate=${this.dateVal[0]}&edate=${
	//        this.dateVal[1]
	//      }`;
	
	        pdataEx2(p, this.$cookie.getCookie("login")).then(res => {
	          if (res.code == 200) {
	            r.exData = res.data.list;
	          }
	        });
	    }
    }
  },

  mounted() {
    this.getConfig();
    this.getList();
    if(this.$route.query.sdate){
    	 this.pdata.sdate=this.$route.query.sdate;
    	 this.dateVal[0] = this.$route.query.sdate.substring(0,4)+'-'+this.$route.query.sdate.substring(4,6)+'-'+this.$route.query.sdate.substring(6,8)
    }
    if(this.$route.query.edate){
    	 this.pdata.edate=this.$route.query.edate;
    	  this.dateVal[1] = this.$route.query.edate.substring(0,4)+'-'+this.$route.query.edate.substring(4,6)+'-'+this.$route.query.edate.substring(6,8)
    	 
    	 
    }
    if(this.$route.query.product_name){
    	 this.pdata.product_name=this.$route.query.product_name;
    }
    
    this.pdata.index_id=	 this.$route.params.index_id;
    
    document.getElementById("yesterday").focus();
  }
};
</script>

<style scoped>
.dialog {
  max-width: 1000px;
  margin: 0 auto;
}
</style>


<style>
.el-table .warning-row,
.el-table--striped .el-table__body tr.warning-row > td {
  background: oldlace;
}
.noNum {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(255, 220, 211);
  line-height: 48px;
}
.data .el-table__expanded-cell[class*="cell"],
.addata .el-table__expanded-cell[class*="cell"],
.cdata .el-table__expanded-cell[class*="cell"] {
  padding: 0;
  padding-left: 48px;
}
.red{
	color: #FF0000;
}
	.table2{
		background: #FDE2E2;
	}
	.table2.el-table th, .table2.el-table tr{
		background: none;
		
	}
	.table2.el-table th, .table2.el-table tr td{
		background: #FFDCD3 !important;
	}
</style>






// WEBPACK FOOTER //
// pData2.vue?87341ccc